import React, {useRef, useState} from "react"
import {findDOMNode} from "react-dom"

import NewView_getViewsStructure
    , {ViewsStructureFor} from "../../../../core/model2/custom-view/add-custom-view/get-structure"
import {NavigationSectionType} from "../../../../core/model2/navigation/@const"
import AddViewPopover from "../../../../core/gd-ui/add-view/add-view-popover"
import ProjectSession from "../../../../core/model2/project/project-session";
import {AddView_Group} from "../../../../core/gd-ui/add-view/@types";
import NewProjectView_getViewsStructure
    from "../../../../core/model2/custom-view/add-custom-view/get-structure-for-project";
import Menu_IconAdd from "../../components/molecules/icon-add";

type Props = {
    className?              : string

    selectedGroupId         : ID
    navigationSectionType?  : NavigationSectionType
    workspace?              : ProjectSession
}

// const debug = "NavigationMenuNewView"
const debug = false

export default function NavigationMenu_NewView(props:Props) {

    const selfRef:any                   = useRef()
    const [showPopover, setShowPopover] = useState(false)

    const classes = Classes('item', props.className, {
        'selected show-popover': showPopover,
    })

    const togglePopover = (e:any) => {
        e.stopPropagation()
        const newShowPopover = !showPopover
        setShowPopover(newShowPopover)
    }

    const hidePopover = () => {
        setShowPopover(false)
    }


    let viewsStructure : AddView_Group[]
    if (props.workspace) {
        viewsStructure = NewProjectView_getViewsStructure(props.workspace.id)
    } else {
        viewsStructure = NewView_getViewsStructure(ViewsStructureFor.NAVIGATION_SECTION, {navigationSectionType:props.navigationSectionType})
    }


    debug && console.log(debug, 'render', props.navigationSectionType, viewsStructure)

    return (
        <div ref={selfRef} className={classes} onClick={togglePopover}>
            <div className="row">
                <div className="flex-row-between-center w-100-percent">
                    <div className="flex-row-left-center">
                        <Menu_IconAdd />
                        <div className="name">New View</div>
                    </div>

                    <div className="item-popover-arrow ui5-ico-12 i5-angle-right"/>
                </div>
            </div>

            {showPopover &&
                <AddViewPopover viewsStructure  = {viewsStructure}
                                selectedGroupId = {props.selectedGroupId}
                                height          = {400}
                                getTargetFunc   = {()=>findDOMNode(selfRef.current)}
                                hidePopover     = {hidePopover}/>}
        </div>
    )
}